import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPAFormOneStart,
  postPAFormOneSuccess,
  postPAFormOneDataSuccess,
  postPAFormOneFailure,
} from "../reducers/postPAFormOneReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPAFormOne = createAsyncThunk(
  "postPAFormOne",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPAFormOneStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/PA/SavePAFirstPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPAFormOneSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postPAFormOneDataSuccess(values));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPAFormOneFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPAFormOneFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPAFormOneFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
